var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerCalendarRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 16.25H4.5C4.10218 16.25 3.72064 16.092 3.43934 15.8107C3.15804 15.5294 3 15.1478 3 14.75V5.75C3 5.35218 3.15804 4.97064 3.43934 4.68934C3.72064 4.40804 4.10218 4.25 4.5 4.25H13.5C13.8978 4.25 14.2794 4.40804 14.5607 4.68934C14.842 4.97064 15 5.35218 15 5.75V8M12 2.75V5.75M6 2.75V5.75M3 8.75H12",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 11L11.9999 12.5M11.9999 12.5H14.2499C14.6147 12.5 14.9739 12.5886 15.2968 12.7583C15.6196 12.928 15.8964 13.1736 16.1032 13.474C16.31 13.7744 16.4408 14.1206 16.4841 14.4828C16.5274 14.8449 16.482 15.2121 16.3519 15.5529C16.2217 15.8936 16.0107 16.1975 15.737 16.4386C15.4633 16.6796 15.1351 16.8505 14.7806 16.9365C14.4262 17.0225 14.0562 17.0211 13.7024 16.9323C13.3487 16.8436 13.0218 16.6702 12.7499 16.427M11.9999 12.5L13.4999 14",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerCalendarRepeat);
export default __webpack_public_path__ + "static/media/tabler_calendar-repeat.f53efcd1e59882d6339bcf33f7e8a9ed.svg";
export { ForwardRef as ReactComponent };